import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        mod => mod.DashboardModule,
      ),
  },
  // Auth
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(
        mod => mod.AuthModule
      )
  },
  {
    // Dropdown (Contact Type) form
    path: 'signup',
    loadChildren: () =>
      import('./modules/auth/sign-up/sign-up.module').then(
        mod => mod.SignUpModule
      )
  },
  {
    // Same form WITHOUT the Contact Type dropdown
    path: 'melbournesignup',
    loadChildren: () =>
      import('./modules/auth/sign-up/sign-up.module').then(
        mod => mod.SignUpModule
      )
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ]
})
export class AppRoutingModule { }
